'use strict';

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

define(['app', 'columboConfig', 'columboEvents', 'columboMetrics', 'siteObj', '$console', 'webVitals', '$window'], function (app, columboConfig, columboEvents, columboMetrics, siteObj, $console, webVitals, $window) {
  var Columbo = function Columbo() {
    var _this = this;

    var module = {};
    var _columboEvents = columboEvents();
    var _columboMetrics = columboMetrics();

    var _init = function _init() {
      module.fastenEvents();
      module.fastenPages();
      module.columboEvents.elementClicked(module.getByTriggerType('componentClicked'), module.publishEvent);
      module.columboEvents.elementViewed(module.getByTriggerType('componentViewed'), module.publishEvent);
      module.columboEvents.elementFocused(module.getByTriggerType('componentFocused'), module.publishEvent);
      module.columboEvents.elementHovered(module.getByTriggerType('componentHovered'), module.publishEvent);
      module.columboEvents.createCustomDivSpies(module.filterByTriggerType('spy'));

      webVitals.getCLS(module.columboMetrics.addWebVitalsValue);
      webVitals.getFCP(module.columboMetrics.addWebVitalsValue);
      webVitals.getFID(module.columboMetrics.addWebVitalsValue);
      webVitals.getLCP(module.columboMetrics.addWebVitalsValue);
      webVitals.getTTFB(module.columboMetrics.addWebVitalsValue);
      module.sendPeformance();
    };

    var _getByTriggerType = function _getByTriggerType(triggerType) {
      return columboConfig.find(function (configElement) {
        return configElement.trigger.type === triggerType;
      });
    };

    var _filterByTriggerType = function _filterByTriggerType(triggerType) {
      return columboConfig.filter(function (configElement) {
        return configElement.trigger.type === triggerType;
      });
    };

    var _fastenEvents = function _fastenEvents() {
      return module.filterByTriggerType('event').map(function (configElement) {
        return module.fastenEvent(configElement);
      });
    };

    var _fastenPages = function _fastenPages() {
      return module.filterByTriggerType('page').map(function (configElement) {
        return module.fastenPage(configElement);
      });
    };

    var _fastenEvent = function _fastenEvent(configElement) {
      app.subscribe(configElement.trigger.event, function () {
        module.publishEvent(configElement, arguments);
      });
    };

    var _getResourceTiming = function _getResourceTiming() {
      var resourceEntry = [];
      function perfObserver(list) {
        return list.getEntries().forEach(function (entry) {
          if (entry.name.includes('https://try.abtasty.com/')) {
            resourceEntry.push({
              'name': entry.name,
              'timeToFirstByte': entry.responseStart - entry.startTime,
              'transfer': entry.responseEnd - entry.responseStart,
              'total': entry.responseEnd - entry.startTime,
              'encodedFileSize': (entry.transferSize / 1024).toFixed(2)
            });
          }
        });
      }

      var observer = new PerformanceObserver(perfObserver);
      observer.observe({ type: 'resource', buffered: true });
      return resourceEntry;
    };

    var _fastenPage = function _fastenPage(configElement) {
      if (module.isDocumentLoaded(configElement.trigger.event)) {
        module.publishEvent(configElement);
      } else {
        window.addEventListener(configElement.trigger.event, function () {
          return module.publishEvent(configElement);
        });
      }
    };

    var _isDocumentLoaded = function _isDocumentLoaded(event) {
      return event === 'load' && document.readyState === 'complete';
    };

    var _publishEvent = function _publishEvent(configElement) {
      var args = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

      var eventData = module.columboMetrics.getMetrics(configElement.publish.metrics, args);

      if (siteObj.debugFlag) {
        $console.log('%cColumbo Event: "' + configElement.publish.event + '"', 'background: #222; color: #bada55', eventData);
      }

      eventData.key = configElement.key;
      app.publish(configElement.publish.event, eventData);
    };

    var _sendPeformance = function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var cwv, metricCleanup;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                cwv = {};

                metricCleanup = function metricCleanup(metric) {
                  switch (metric.name) {
                    case 'CLS':
                      cwv.cumulativeLayoutShift = metric.value;
                      break;
                    case 'FCP':
                      cwv['firstContentfulPaint'] = Math.trunc(metric.value);
                      break;
                    case 'FID':
                      cwv['firstInputDelay'] = Math.trunc(metric.value);
                      break;
                    case 'LCP':
                      cwv['largestContentfulPaint'] = Math.trunc(metric.value);
                      break;
                    case 'TTFB':
                      cwv['timeToFirstByte'] = Math.trunc(metric.value);
                      break;
                    default:
                      cwv[metric.name] = metric.value;
                  }
                };

                webVitals.getCLS(metricCleanup, true);
                webVitals.getFCP(metricCleanup);
                webVitals.getFID(metricCleanup);
                webVitals.getLCP(metricCleanup);
                webVitals.getTTFB(metricCleanup);

                window.addEventListener("load", function (event) {
                  if (siteObj.features.enableAbtasty) {
                    $window.dataLayer.push({
                      'event': 'elysiumEvent',
                      'eventData': {
                        'abtasty': module.getResourceTiming(),
                        'performance': module.columboMetrics.getPerformanceStats(),
                        "webVitals": cwv
                      }
                    });
                  }
                });

              case 8:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }));

      return function _sendPeformance() {
        return _ref.apply(this, arguments);
      };
    }();

    module.columboEvents = _columboEvents;
    module.columboMetrics = _columboMetrics;
    module.columboConfig = columboConfig;
    module.fastenEvents = _fastenEvents;
    module.fastenPages = _fastenPages;
    module.fastenEvent = _fastenEvent;
    module.fastenPage = _fastenPage;
    module.filterByTriggerType = _filterByTriggerType;
    module.getByTriggerType = _getByTriggerType;
    module.init = _init;
    module.isDocumentLoaded = _isDocumentLoaded;
    module.publishEvent = _publishEvent;
    module.sendPeformance = _sendPeformance;
    module.getResourceTiming = _getResourceTiming;

    module.init();
    return module;
  };

  return Columbo();
});
//# sourceMappingURL=columbo.js.map
